import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/projects',
        name: 'projects',
        component: () =>
            import ('../views/project/projects.vue')
    },
    {


        path: '/test',
        name: 'test',
        component: () =>
            import ('../views/test/index.vue')
    },
    {


        path: '/buys',
        name: 'buys',
        component: () =>
            import ('../views/test/buyordercollection.vue')
    },
    {


        path: '/buy',
        name: 'buy',
        component: () =>
            import ('../views/test/buyorder.vue')
    },
    {


        path: '/selllist',
        name: 'selllist',
        component: () =>
            import ('../views/test/sellorderList')
    },
    {


        path: '/buylist',
        name: 'buylist',
        component: () =>
            import ('../views/test/buyorderList')
    },
    {


        path: '/cancelorder',
        name: 'cancelorder',
        component: () =>
            import ('../views/test/cancelorderList')
    },
    {
        path: '/projectDetail/:projectID',
        name: 'projectDetail',
        component: () =>
            import ('../views/project/projectDetail/projectDetail.vue'),
        children: [{
            path: 'gallery',
            name: 'gallery',
            component: () =>
                import ('../views/project/projectDetail/gallery.vue')
        }]
    },
    {
        path: '/user/:address',
        name: 'user',
        component: () =>
            import ('../views/user/user.vue'),
    },
    {
        path: '/token/:tokenID',
        name: 'token',
        component: () =>
            import ('../views/project/token/token.vue')
    },
    {
        path: '/cookie',
        name: 'cookie',
        component: () =>
            import ('../views/test/cookie.vue')
    },
    {
        path: '/members',
        name: 'members',
        component: () =>
            import ('../views/members/members.vue')
    },
    {
        path: '/profile/:profileID',
        name: 'profile',
        component: () =>
            import ('../views/members/profile.vue')
    },
    {
        path: '/faq',
        name: 'faq',
        component: () =>
            import ('../views/members/faq.vue')
    },
];

const router = new VueRouter({
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});


const adminRoute = [{
        path: '/manage/audit',
        name: 'artList',
        component: () =>
            import ('../views/manage/audit/index.vue')
    },
    {
        name: 'projectList',
        path: '/manage/allProjects',
        component: () =>
        import ('../views/manage/projects/index.vue'),
    },
    //   {
    //   path: '/manage/detail/:projectId/:tokenId',
    //   name: 'detail',
    //   component: () => import ('../views/manage/detail/index.vue')
    // }
];

const artistRoute = [{
        name: 'createArt',
        path: '/manage/create',
        component: () =>
            import ('../views/manage/create/index.vue'),
    },
    {
        name: 'projectList',
        path: '/manage/projects',
        component: () =>
            import ('../views/manage/projects/index.vue'),
    },
    {
        name: 'peojectSettings',
        path: '/manage/settings/:projectId',
        component: () =>
            import ('../views/manage/settings/index.vue'),
    },
    {
        path: '/manage/edit/:projectId/:tokenId',
        name: 'editProject',
        component: () =>
            import ('../views/manage/edit/index.vue')
    },
    {
        path: '/manage/preview/:projectId/:tokenId',
        name: 'preview',
        component: () =>
            import ('../views/manage/preview/index.vue')
    },
    {
        path: '/uploadImage/:projectId',
        name: 'upload',
        component: () =>
            import ('../views/upload/uploadImage.vue')
    },
    {
        path: '/createAttr/:projectId',
        name: 'newAttr',
        component: () =>
            import ('../views/upload/newAttr.vue')
    },
];

export const getRoleRoutes = (role) => {
    if (role === 'all') {
        return routes.concat(adminRoute, artistRoute);
    } else if (role === 'admin') {
        return routes.concat(adminRoute);
    } else if (role === 'artist') {
        return routes.concat(artistRoute);
    } else {
        return routes;
    }
};

export default router;
